import { Record } from "immutable";

export const Model = <T extends { [key: string]: any }>(data: T): Record.Class => {
  return Record(data);
};
